<template>
  <ui-modal
    ref="gestionar-ps-modal"
    title="Gestionar planificaciones semanales"
    size="auto"
    @close="closeManageModal()">

    <Button
      :size="15"
      color="#28a745"
      colorText="#ffffff"
      tooltip="Agregar planificación semanal"
      icon="fas fa-plus"
      round
      :width="30"
      class="mr-2"
      traslate
      @click.native="add_new = true"
      v-if="!add_new"
    />

    <!-- tabla para agregar los nuevos planes -->
    <div v-if="add_new" class="w-100">
      <fieldset-component texto="Nuevo plan semanal" class="mb-3" />
      <div class="d-flex w-100 mt-3">
        <table class="table table-striped w-100">
          <thead>
          <th class="text-md-break">Pto. Destino</th>
          <th v-if="psIsAdmin" class="text-md-break">Cliente</th>
          <th class="text-md-break">Tipo Contenedor</th>
          <th class="text-md-break">Tipo Producto</th>
          <th class="text-md-break border-left border-right p-0">
            <div class="d-flex flex-column justify-content-center p-0">
              <div class="d-flex justify-content-center">
                <span>Sem. {{ psCurrentWeeks[0] }}</span>
              </div>
              <div class="d-flex justify-content-around">
                <td v-if="!psIsAdmin" class="border-top-0 text-md-break pl-0 pt-0 pb-0">
                  <span tabindex="0" title="Cliente">CL</span>
                </td>
                <td v-if="psIsAdmin" class="border-top-0 text-md-break p-0">
                  <span tabindex="0" title="Planificación semanal">PS</span>
                </td>
              </div>
            </div>
          </th>
          <th class="text-md-break border-left border-right p-0">
            <div class="d-flex flex-column justify-content-center p-0">
              <div class="d-flex justify-content-center">
                <span>Sem. {{ psCurrentWeeks[1] }}</span>
              </div>
              <div class="d-flex justify-content-around">
                <td v-if="!psIsAdmin" class="border-top-0 text-md-break pl-0 pt-0 pb-0">
                  <span tabindex="0" title="Cliente">CL</span>
                </td>
                <td v-if="psIsAdmin" class="border-top-0 text-md-break p-0">
                  <span tabindex="0" title="Planificación semanal">PS</span>
                </td>
              </div>
            </div>
          </th>
          <th class="text-md-break border-left border-right p-0">
            <div class="d-flex flex-column justify-content-center p-0">
              <div class="d-flex justify-content-center">
                <span>Sem. {{ psCurrentWeeks[2] }}</span>
              </div>
              <div class="d-flex justify-content-around">
                <td v-if="!psIsAdmin" class="border-top-0 text-md-break pl-0 pt-0 pb-0">
                  <span tabindex="0" title="Cliente">CL</span>
                </td>
                <td v-if="psIsAdmin" class="border-top-0 text-md-break p-0">
                  <span tabindex="0" title="Planificación semanal">PS</span>
                </td>
              </div>
            </div>
          </th>
          <th class="text-md-break border-left border-right p-0">
            <div class="d-flex flex-column justify-content-center p-0">
              <div class="d-flex justify-content-center">
                <span>Sem. {{ psCurrentWeeks[3] }}</span>
              </div>
              <div class="d-flex justify-content-around">
                <td v-if="!psIsAdmin" class="border-top-0 text-md-break pl-0 pt-0 pb-0">
                  <span tabindex="0" title="Cliente">CL</span>
                </td>
                <td v-if="psIsAdmin" class="border-top-0 text-md-break p-0">
                  <span tabindex="0" title="Planificación semanal">PS</span>
                </td>
              </div>
            </div>
          </th>
          <th class="text-md-break border-left border-right p-0">
            <div class="d-flex flex-column justify-content-center p-0">
              <div class="d-flex justify-content-center">
                <span>Sem. {{ psCurrentWeeks[4] }}</span>
              </div>
              <div class="d-flex justify-content-around">
                <td v-if="!psIsAdmin" class="border-top-0 text-md-break pl-0 pt-0 pb-0">
                  <span tabindex="0" title="Cliente">CL</span>
                </td>
                <td v-if="psIsAdmin" class="border-top-0 text-md-break p-0">
                  <span tabindex="0" title="Planificación semanal">PS</span>
                </td>
              </div>
            </div>
          </th>
          </thead>
          <tbody>
          <tr>
            <td>
              <select class="form-control" v-model="new_plan_obj.port_id">
                <option value="">Seleccione una opción</option>
                <option v-for="(port, index) in psListaPuertos" :key="index" :value="port.id">
                  {{ port.name }}
                </option>
              </select>
            </td>
            <td v-if="psIsAdmin">
              <select class="form-control" v-model="new_plan_obj.client_id">
                <option value="">Seleccione una opción</option>
                <option v-for="(client, index) in psListaClientes" :key="index" :value="client.id">
                  {{ client.name }}
                </option>
              </select>
            </td>
            <td>
              <select class="form-control" v-model="new_plan_obj.container_id"
                      @change="setNewPSProducts">
                <option value="">Seleccione una opción</option>
                <option v-for="(container, index) in psListaContenedores" :key="index" :value="container.id">
                  {{ container.name }}
                </option>
              </select>
            </td>
            <td>
              <select class="form-control" v-model="new_plan_obj.product_id" :disabled="!psEnabledButtons">
                <option value="">Seleccione una opción</option>
                <option v-for="(product, index) in psNewPlanningProducts" :key="index" :value="product.id">
                  {{ product.name }}
                </option>
              </select>
            </td>
            <td>
              <div class="d-flex justify-content-center">
                <td v-if="!psIsAdmin" class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
                  <input
                    class="form-control"
                    type="text"
                    v-mask="'###'"
                    placeholder="Ingrese una cantidad"
                    v-model="new_plan_obj.weekly_plans[0].client_qty">
                </td>
                <td v-if="psIsAdmin" class="border-top-0 text-md-break p-0 px-3">
                  <input
                    class="form-control"
                    type="text"
                    v-mask="negative_qty_mask"
                    placeholder="Ingrese una cantidad"
                    v-model="new_plan_obj.weekly_plans[0].ucc_qty">
                </td>
              </div>
            </td>
            <td>
              <div class="d-flex justify-content-center">
                <td v-if="!psIsAdmin" class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
                  <input
                    class="form-control"
                    placeholder="Ingrese una cantidad"
                    type="text"
                    v-mask="'###'"
                    v-model="new_plan_obj.weekly_plans[1].client_qty">
                </td>
                <td v-if="psIsAdmin" class="border-top-0 text-md-break p-0 px-3">
                  <input
                    class="form-control"
                    type="text"
                    v-mask="negative_qty_mask"
                    placeholder="Ingrese una cantidad"
                    v-model="new_plan_obj.weekly_plans[1].ucc_qty">
                </td>
              </div>
            </td>
            <td>
              <div class="d-flex justify-content-center">
                <td v-if="!psIsAdmin" class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
                  <input
                    class="form-control"
                    type="text"
                    v-mask="'###'"
                    placeholder="Ingrese una cantidad"
                    v-model="new_plan_obj.weekly_plans[2].client_qty">
                </td>
                <td v-if="psIsAdmin" class="border-top-0 text-md-break p-0 px-3">
                  <input
                    class="form-control"
                    type="text"
                    v-mask="negative_qty_mask"
                    placeholder="Ingrese una cantidad"
                    v-model="new_plan_obj.weekly_plans[2].ucc_qty">
                </td>
              </div>
            </td>
            <td>
              <div class="d-flex justify-content-center">
                <td v-if="!psIsAdmin" class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
                  <input
                    class="form-control"
                    type="text"
                    v-mask="'###'"
                    placeholder="Ingrese una cantidad"
                    v-model="new_plan_obj.weekly_plans[3].client_qty">
                </td>
                <td v-if="psIsAdmin" class="border-top-0 text-md-break p-0 px-3">
                  <input
                    class="form-control"
                    type="text"
                    v-mask="negative_qty_mask"
                    placeholder="Ingrese una cantidad"
                    v-model="new_plan_obj.weekly_plans[3].ucc_qty">
                </td>
              </div>
            </td>
            <td>
              <div class="d-flex justify-content-center">
                <td v-if="!psIsAdmin" class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
                  <input
                    class="form-control"
                    type="text"
                    v-mask="'###'"
                    placeholder="Ingrese una cantidad"
                    v-model="new_plan_obj.weekly_plans[4].client_qty">
                </td>
                <td v-if="psIsAdmin" class="border-top-0 text-md-break p-0 px-3">
                  <input
                    class="form-control"
                    type="text"
                    v-mask="negative_qty_mask"
                    placeholder="Ingrese una cantidad"
                    v-model="new_plan_obj.weekly_plans[4].ucc_qty">
                </td>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-between mt-5">
        <button
          class="btn btn-secondary"
          style="margin-right: 50px"
          @click="add_new = false, clearNewWeeklyPlanForm()">
          Cancelar
        </button>
        <div style="float: right">
          <button
            class="btn btn-secondary"
            style="margin-right: 20px"
            @click="clearNewWeeklyPlanForm">
            Limpiar
          </button>
          <button class="btn btn-danger mr-3" @click="addNewWeeklyPlan">
            Agregar
          </button>
        </div>
      </div>
    </div>

    <!-- tabla para ver los planes actuales a agregados -->
    <div class="w-100 mt-4">
      <fieldset-component :texto="management_title" class="mb-3" />
      <div class="d-flex w-100 mt-3">
        <table class="table table-striped w-100">
          <thead>
          <th class="text-md-break">Pto. Destino</th>
          <th v-if="psIsAdmin" class="text-md-break">Cliente</th>
          <th class="text-md-break">Tipo Contenedor</th>
          <th class="text-md-break">Tipo Producto</th>
          <th class="text-md-break border-left border-right p-0">
            <div class="d-flex flex-column justify-content-center p-0">
              <div class="d-flex justify-content-center">
                <span>Sem. {{ psCurrentWeeks[0] }}</span>
              </div>
              <div class="d-flex justify-content-around">
                <td v-if="!psIsAdmin" class="border-top-0 text-md-break pl-0 pt-0 pb-0">
                  <span tabindex="0" title="Cliente">CL</span>
                </td>
                <td v-if="psIsAdmin" class="border-top-0 text-md-break p-0">
                  <span tabindex="0" title="Planificación semanal">PS</span>
                </td>
              </div>
            </div>
          </th>
          <th class="text-md-break border-left border-right p-0">
            <div class="d-flex flex-column justify-content-center p-0">
              <div class="d-flex justify-content-center">
                <span>Sem. {{ psCurrentWeeks[1] }}</span>
              </div>
              <div class="d-flex justify-content-around">
                <td v-if="!psIsAdmin" class="border-top-0 text-md-break pl-0 pt-0 pb-0">
                  <span tabindex="0" title="Cliente">CL</span>
                </td>
                <td v-if="psIsAdmin" class="border-top-0 text-md-break p-0">
                  <span tabindex="0" title="Planificación semanal">PS</span>
                </td>
              </div>
            </div>
          </th>
          <th class="text-md-break border-left border-right p-0">
            <div class="d-flex flex-column justify-content-center p-0">
              <div class="d-flex justify-content-center">
                <span>Sem. {{ psCurrentWeeks[2] }}</span>
              </div>
              <div class="d-flex justify-content-around">
                <td v-if="!psIsAdmin" class="border-top-0 text-md-break pl-0 pt-0 pb-0">
                  <span tabindex="0" title="Cliente">CL</span>
                </td>
                <td v-if="psIsAdmin" class="border-top-0 text-md-break p-0">
                  <span tabindex="0" title="Planificación semanal">PS</span>
                </td>
              </div>
            </div>
          </th>
          <th class="text-md-break border-left border-right p-0">
            <div class="d-flex flex-column justify-content-center p-0">
              <div class="d-flex justify-content-center">
                <span>Sem. {{ psCurrentWeeks[3] }}</span>
              </div>
              <div class="d-flex justify-content-around">
                <td v-if="!psIsAdmin" class="border-top-0 text-md-break pl-0 pt-0 pb-0">
                  <span tabindex="0" title="Cliente">CL</span>
                </td>
                <td v-if="psIsAdmin" class="border-top-0 text-md-break p-0">
                  <span tabindex="0" title="Planificación semanal">PS</span>
                </td>
              </div>
            </div>
          </th>
          <th class="text-md-break border-left border-right p-0">
            <div class="d-flex flex-column justify-content-center p-0">
              <div class="d-flex justify-content-center">
                <span>Sem. {{ psCurrentWeeks[4] }}</span>
              </div>
              <div class="d-flex justify-content-around">
                <td v-if="!psIsAdmin" class="border-top-0 text-md-break pl-0 pt-0 pb-0">
                  <span tabindex="0" title="Cliente">CL</span>
                </td>
                <td v-if="psIsAdmin" class="border-top-0 text-md-break p-0">
                  <span tabindex="0" title="Planificación semanal">PS</span>
                </td>
              </div>
            </div>
          </th>
          <th class="text-md-break">Acciones</th>
          </thead>
          <tbody v-if="psDataSelected.length >= 1 || new_plans.length >= 1">
          <tr v-for="(row, row_index) in psDataSelected" :key="'selected' + row_index">
            <td>
              <select class="form-control" v-model="row.port_id">
                <option value="">Seleccione una opción</option>
                <option v-for="(port, index) in psListaPuertos" :key="index" :value="port.id">
                  {{ port.name }}
                </option>
              </select>
            </td>
            <td v-if="psIsAdmin">
              <select class="form-control" v-model="row.client_id" :disabled="!psIsAdmin">
                <option value="">Seleccione una opción</option>
                <option v-for="(client, index) in psListaClientes" :key="index" :value="client.id">
                  {{ client.name }}
                </option>
              </select>
            </td>
            <td>
              <select class="form-control" v-model="row.container_id"
                      @change="setExistingPSProducts({ index: row.temp_id, container_id: row.container_id})">
                <option value="">Seleccione una opción</option>
                <option v-for="(container, index) in psListaContenedores" :key="index" :value="container.id">
                  {{ container.name }}
                </option>
              </select>
            </td>
            <td>
              <select class="form-control" v-model="row.product_id" :disabled="!psEnabledButtons">
                <option value="">Seleccione una opción</option>
                <option v-for="(product, index) in psExistingPlanningProducts[psProductsPrefix + row.temp_id]"
                        :key="index"
                        :value="product.id">
                  {{ product.name }}
                </option>
              </select>
            </td>
            <td>
              <div class="d-flex justify-content-center">
                <td v-if="!psIsAdmin" class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
                  <input
                    class="form-control"
                    type="text"
                    v-mask="'###'"
                    :disabled="row.weekly_plans[0].locked"
                    placeholder="Ingrese una cantidad"
                    v-model="row.weekly_plans[0].client_qty">
                </td>
                <td v-if="psIsAdmin" class="border-top-0 text-md-break p-0 px-3">
                  <input
                    class="form-control"
                    type="text"
                    v-mask="negative_qty_mask"
                    :disabled="row.weekly_plans[0].locked"
                    placeholder="Ingrese una cantidad"
                    v-model="row.weekly_plans[0].ucc_qty">
                </td>
              </div>
            </td>
            <td>
              <div class="d-flex justify-content-center">
                <td v-if="!psIsAdmin" class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
                  <input
                    class="form-control"
                    placeholder="Ingrese una cantidad"
                    type="text"
                    v-mask="'###'"
                    :disabled="row.weekly_plans[1].locked"
                    v-model="row.weekly_plans[1].client_qty">
                </td>
                <td v-if="psIsAdmin" class="border-top-0 text-md-break p-0 px-3">
                  <input
                    class="form-control"
                    type="text"
                    v-mask="negative_qty_mask"
                    :disabled="row.weekly_plans[1].locked"
                    placeholder="Ingrese una cantidad"
                    v-model="row.weekly_plans[1].ucc_qty">
                </td>
              </div>
            </td>
            <td>
              <div class="d-flex justify-content-center">
                <td v-if="!psIsAdmin" class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
                  <input
                    class="form-control"
                    type="text"
                    v-mask="'###'"
                    :disabled="row.weekly_plans[2].locked"
                    placeholder="Ingrese una cantidad"
                    v-model="row.weekly_plans[2].client_qty">
                </td>
                <td v-if="psIsAdmin" class="border-top-0 text-md-break p-0 px-3">
                  <input
                    class="form-control"
                    type="text"
                    v-mask="negative_qty_mask"
                    :disabled="row.weekly_plans[2].locked"
                    placeholder="Ingrese una cantidad"
                    v-model="row.weekly_plans[2].ucc_qty">
                </td>
              </div>
            </td>
            <td>
              <div class="d-flex justify-content-center">
                <td v-if="!psIsAdmin" class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
                  <input
                    class="form-control"
                    type="text"
                    v-mask="'###'"
                    :disabled="row.weekly_plans[3].locked"
                    placeholder="Ingrese una cantidad"
                    v-model=" row.weekly_plans[3].client_qty">
                </td>
                <td v-if="psIsAdmin" class="border-top-0 text-md-break p-0 px-3">
                  <input
                    class="form-control"
                    type="text"
                    v-mask="negative_qty_mask"
                    :disabled="row.weekly_plans[3].locked"
                    placeholder="Ingrese una cantidad"
                    v-model="row.weekly_plans[3].ucc_qty">
                </td>
              </div>
            </td>
            <td>
              <div class="d-flex justify-content-center">
                <td v-if="!psIsAdmin" class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
                  <input
                    class="form-control"
                    type="text"
                    v-mask="'###'"
                    :disabled="row.weekly_plans[4].locked"
                    placeholder="Ingrese una cantidad"
                    v-model="row.weekly_plans[4].client_qty">
                </td>
                <td v-if="psIsAdmin" class="border-top-0 text-md-break p-0 px-3">
                  <input
                    class="form-control"
                    type="text"
                    v-mask="negative_qty_mask"
                    :disabled="row.weekly_plans[4].locked"
                    placeholder="Ingrese una cantidad"
                    v-model="row.weekly_plans[4].ucc_qty">
                </td>
              </div>
            </td>
            <td>
              <p class="text-center">--</p>
            </td>
          </tr>
          <tr v-for="(new_plan, new_plan_index) in new_plans" :key="'added' + new_plan_index">
            <td>
              <select class="form-control" v-model="new_plan.port_id">
                <option value="">Seleccione una opción</option>
                <option v-for="(port, index) in psListaPuertos" :key="index" :value="port.id">
                  {{ port.name }}
                </option>
              </select>
            </td>
            <td v-if="psIsAdmin">
              <select class="form-control" v-model="new_plan.client_id" :disabled="!psIsAdmin">
                <option value="">Seleccione una opción</option>
                <option v-for="(client, index) in psListaClientes" :key="index" :value="client.id">
                  {{ client.name }}
                </option>
              </select>
            </td>
            <td>
              <select class="form-control" v-model="new_plan.container_id"
                      @change="setAddedPSProducts({index: new_plan_index, container_id: new_plan.container_id})">
                <option value="">Seleccione una opción</option>
                <option v-for="(container, index) in psListaContenedores" :key="index" :value="container.id">
                  {{ container.name }}
                </option>
              </select>
            </td>
            <td>
              <select class="form-control" v-model="new_plan.product_id" :disabled="!psEnabledButtons">
                <option value="">Seleccione una opción</option>
                <option v-for="(product, index) in psAddedPlanningProducts[psProductsPrefix + new_plan_index]"
                        :key="index"
                        :value="product.id">
                  {{ product.name }}
                </option>
              </select>
            </td>
            <td>
              <div class="d-flex justify-content-center">
                <td v-if="!psIsAdmin" class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
                  <input
                    class="form-control"
                    type="text"
                    v-mask="'###'"
                    placeholder="Ingrese una cantidad"
                    v-model="new_plan.weekly_plans[0].client_qty">
                </td>
                <td v-if="psIsAdmin" class="border-top-0 text-md-break p-0 px-3">
                  <input
                    class="form-control"
                    type="text"
                    v-mask="negative_qty_mask"
                    placeholder="Ingrese una cantidad"
                    v-model="new_plan.weekly_plans[0].ucc_qty">
                </td>
              </div>
            </td>
            <td>
              <div class="d-flex justify-content-center">
                <td v-if="!psIsAdmin" class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
                  <input
                    class="form-control"
                    placeholder="Ingrese una cantidad"
                    type="text"
                    v-mask="'###'"
                    v-model="new_plan.weekly_plans[1].client_qty" :disabled="psIsAdmin">
                </td>
                <td v-if="psIsAdmin" class="border-top-0 text-md-break p-0 px-3">
                  <input
                    class="form-control"
                    type="text"
                    v-mask="negative_qty_mask"
                    placeholder="Ingrese una cantidad"
                    v-model="new_plan.weekly_plans[1].ucc_qty">
                </td>
              </div>
            </td>
            <td>
              <div class="d-flex justify-content-center">
                <td v-if="!psIsAdmin" class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
                  <input
                    class="form-control"
                    type="text"
                    v-mask="'###'"
                    placeholder="Ingrese una cantidad"
                    v-model="new_plan.weekly_plans[2].client_qty">
                </td>
                <td v-if="psIsAdmin" class="border-top-0 text-md-break p-0 px-3">
                  <input
                    class="form-control"
                    type="text"
                    v-mask="negative_qty_mask"
                    placeholder="Ingrese una cantidad"
                    v-model="new_plan.weekly_plans[2].ucc_qty">
                </td>
              </div>
            </td>
            <td>
              <div class="d-flex justify-content-center">
                <td v-if="!psIsAdmin" class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
                  <input
                    class="form-control"
                    type="text"
                    v-mask="'###'"
                    placeholder="Ingrese una cantidad"
                    v-model="new_plan.weekly_plans[3].client_qty">
                </td>
                <td v-if="psIsAdmin" class="border-top-0 text-md-break p-0 px-3">
                  <input
                    class="form-control"
                    type="text"
                    v-mask="negative_qty_mask"
                    placeholder="Ingrese una cantidad"
                    v-model="new_plan.weekly_plans[3].ucc_qty">
                </td>
              </div>
            </td>
            <td>
              <div class="d-flex justify-content-center">
                <td v-if="!psIsAdmin" class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
                  <input
                    class="form-control"
                    type="text"
                    v-mask="'###'"
                    placeholder="Ingrese una cantidad"
                    v-model="new_plan.weekly_plans[4].client_qty">
                </td>
                <td v-if="psIsAdmin" class="border-top-0 text-md-break p-0 px-3">
                  <input
                    class="form-control"
                    type="text"
                    v-mask="negative_qty_mask"
                    placeholder="Ingrese una cantidad"
                    v-model="new_plan.weekly_plans[4].ucc_qty">
                </td>
              </div>
            </td>
            <td>
              <a class="btn btn-sm icono" style="text-align: center; width: 100%"
                 @click="removeNewWeeklyPlan(new_plan_index)">
                <i class="fa fa-times text-danger"
                   style="text-align: center; font-size: 11.7px">
                </i>
              </a>
            </td>
          </tr>
          </tbody>
          <tbody v-else>
          <tr>
            <td colspan="17">
              <p class="text-center mt-3">No hay datos seleccionados o agregados</p>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-between mt-5">
        <button class="btn btn-default"
                @click="closeManageModal()">
          Cerrar
        </button>
        <div style="float: right">
          <button v-if="psCreateMode"
                  class="btn btn-danger mr-3"
                  @click="createWeeklyPlans"
                  :disabled="!psEnabledButtons || new_plans.length <= 0">
            Guardar nuevos
          </button>
          <button v-else class="btn btn-danger mr-3"
                  @click="modifyWeeklyPlans"
                  :disabled="!psEnabledButtons">
            Guardar cambios
          </button>
        </div>
      </div>
    </div>
  </ui-modal>
</template>

<script>

import { mapActions, mapState } from "vuex";

// Keen UI
import UiModal from "keen-ui/src/UiModal";
import Button from "@/components/common/Button.vue";
import FieldsetComponent from "@/components/common/FieldsetComponent.vue";
import { crearPlanificacionSemanal, editarPlanificacionSemanal } from "@/constants/lineas";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { filtrarPlanificacionSemanal } from "../../../../constants/lineas";

const negative_qty_mask = createNumberMask({
  prefix: "",
  integerLimit: 3,
  allowNegative: true
});

export default {
  data() {
    return {
      negative_qty_mask,
      add_new: false,
      new_plan_obj: {
        port_id: "",
        client_id: "",
        container_id: "",
        product_id: "",
        weekly_plans: [
          {
            annual_qty: 0,
            client_qty: 0,
            ucc_qty: 0
          },
          {
            annual_qty: 0,
            client_qty: 0,
            ucc_qty: 0
          },
          {
            annual_qty: 0,
            client_qty: 0,
            ucc_qty: 0
          },
          {
            annual_qty: 0,
            client_qty: 0,
            ucc_qty: 0
          },
          {
            annual_qty: 0,
            client_qty: 0,
            ucc_qty: 0
          }
        ]
      },
      new_plans: [],
      management_title: "Planes semanales existentes"
    };
  },
  components: { FieldsetComponent, Button, UiModal },
  computed: {
    ...mapState("lineas", [
        "psShowManageModal",
        "psCreateMode",
        "psDataSelected",
        "psCurrentWeeks",
        "psListaPuertos",
        "psListaContenedores",
        "psListaProductos",
        "psListaClientes",
        "psMultipleEditMode",
        "psEnabledButtons",
        "psProductsPrefix",
        "psNewPlanningProducts",
        "psExistingPlanningProducts",
        "psAddedPlanningProducts",
        "psIsAdmin",
        "currentFiltersPlanificacionSemanal",
        "flagFiltersPlanificacionSemanal"
      ]
    )
  },
  methods: {
    ...mapActions(["ActionSetZindexTablaModal", "ActionSetLoadingTable"]),
    ...mapActions("lineas", [
      "actionSetPSShowManageModal",
      "actionSetPSDataSelected",
      "actionSetPSCreateMode",
      "actionSetPSDataTable",
      "actionSetPSEnabledButtons",
      "actionSetDataPlanificacionSemanalTabla",
      "actionSetPSNewPlanningProducts",
      "actionSetPSExistingPlanningProducts",
      "actionSetPSAddedPlanningProducts",
      "actionSetPSResumeDataTableFiltrada",
      "actionSetPSDataTableFiltrada",
      "actionSetFlagFiltersPlanificacionSemanal"
    ]),
    //create nuevo plan
    async createWeeklyPlans() {

      const self = this;
      let isValid = true;

      this.new_plans.forEach(function callback(item, index) {

        if (item.port_id === "") {
          isValid = false;
          return self.$vToastify.error("Seleccione un puerto", `Error en Puerto: Plan ${index + 1}`);
        }

        if (self.psIsAdmin) {
          if (item.client_id === "") {
            isValid = false;
            return self.$vToastify.error("Seleccione un cliente", `Error en Cliente: Plan ${index + 1}`);
          }
        }

        if (item.container_id === "") {
          isValid = false;
          return self.$vToastify.error("Seleccione un Tipo de Contenedor", `Error en Tipo de Contenedor: Plan ${index + 1}`);
        }
        if (item.product_id === "") {
          isValid = false;
          return self.$vToastify.error("Seleccione un Tipo de Producto", `Error en Tipo de Producto: Plan ${index + 1}`);
        }

        item.weekly_plans.forEach(function callback(week, week_index) {
          if (self.psIsAdmin) {
            if (week.ucc_qty === "") {
              isValid = false;
              return self.$vToastify.error(`Ingrese una cantidad mayor o igual a cero en la planificación para la semana ${self.psCurrentWeeks[week_index]} del plan ${index + 1}`, `Error Cantidad planificación: Plan ${index + 1}`);
            }
          } else {
            if (week.client_qty === "") {
              isValid = false;
              return self.$vToastify.error(`Ingrese una cantidad mayor o igual a cero en la planificación para la semana ${self.psCurrentWeeks[week_index]} del plan ${index + 1}`, `Error Cantidad planificación: Plan ${index + 1}`);
            }
          }
        });
      });

      if (isValid) {

        this.actionSetPSEnabledButtons(false);
        this.$vToastify.loader("Creando planificaciones semanales...");

        let response = await crearPlanificacionSemanal(this.new_plans);

        if (response.code === 200) {

          await this.closeManageModal();
          // await this.actionSetDataPlanificacionSemanalTabla();

          if (this.flagFiltersPlanificacionSemanal) {

            const filterData = await filtrarPlanificacionSemanal(this.currentFiltersPlanificacionSemanal);

            if (this.psIsAdmin && filterData.type === 1) {

              this.actionSetPSResumeDataTableFiltrada(filterData.data);

              if (this.psShowDetail) {

                if (this.puertoModel !== "") {

                  const results = filterData.data.find(x => x.data[0] === this.puertoModel.name);


                  this.actionSetPSDataTableFiltrada(results !== undefined && results.data_complementaria.length >= 1 ? results.data_complementaria : []);

                } else {
                  const results = filterData.data.find(x => x.data[0] === this.psDetailPort);


                  this.actionSetPSDataTableFiltrada(results !== undefined && results.data_complementaria.length >= 1 ? results.data_complementaria : []);

                }

              }

            }else {
              
              this.actionSetPSDataTableFiltrada(filterData.data);

            }
            
          }else{

            await this.closeManageModal();
            await this.actionSetDataPlanificacionSemanalTabla();
            this.$vToastify.success(response.message, "Éxito");

          }



          

            // this.closeModal("modal");

            // }else {

            // this.$vToastify.error(response.message, "Se produjo un error");

            // }
          
          
          // this.actionSetPSResumeDataTableFiltrada(data);


          this.$vToastify.success(response.message, "Éxito");

        } else if (response.code && response.errors) {

          Object.values(response.errors).forEach(errorArray => {
            errorArray.forEach(error => {
              this.$vToastify.error(error, "Error");
            });
          });

        } else {
          this.$vToastify.error(response.message, "Error");
        }

        this.$vToastify.stopLoader();
        this.actionSetPSEnabledButtons(true);
      }

    },
    //modificar planes o agregar nuevo
    async modifyWeeklyPlans() {

      const self = this;
      let isValid = true;

      //valdiacion planes a modificar
      this.psDataSelected.forEach(function callback(item, index) {

        if (item.port_id === "") {
          isValid = false;
          return self.$vToastify.error("Seleccione un puerto", `Error en Puerto: Plan ${index + 1}`);
        }

        if (self.psIsAdmin) {
          if (item.client_id === "") {
            isValid = false;
            return self.$vToastify.error("Seleccione un cliente", `Error en Cliente: Plan ${index + 1}`);
          }
        }

        if (item.container_id === "") {
          isValid = false;
          return self.$vToastify.error("Seleccione un Tipo de Contenedor", `Error en Tipo de Contenedor: Plan ${index + 1}`);
        }
        if (item.product_id === "") {
          isValid = false;
          return self.$vToastify.error("Seleccione un Tipo de Producto", `Error en Tipo de Producto: Plan ${index + 1}`);
        }

        item.weekly_plans.forEach(function callback(week, week_index) {
          if (self.psIsAdmin) {
            if (week.ucc_qty === "") {
              isValid = false;
              return self.$vToastify.error(`Ingrese una cantidad mayor o igual a cero en la planificación para la semana ${self.psCurrentWeeks[week_index]} del plan ${index + 1}`, `Error Cantidad planificación: Plan ${index + 1}`);
            }
          } else {
            if (week.client_qty === "") {
              isValid = false;
              return self.$vToastify.error(`Ingrese una cantidad mayor o igual a cero en la planificación para la semana ${self.psCurrentWeeks[week_index]} del plan ${index + 1}`, `Error Cantidad planificación: Plan ${index + 1}`);
            }
          }
        });
      });

      //validacion planes nuevos agregados
      this.new_plans.forEach(function callback(item, index) {

        if (item.port_id === "") {
          isValid = false;
          return self.$vToastify.error("Seleccione un puerto", `Error en Puerto: Nuevo plan ${index + 1}`);
        }

        if (self.psIsAdmin) {
          if (item.client_id === "") {
            isValid = false;
            return self.$vToastify.error("Seleccione un cliente", `Error en Cliente: Nuevo plan ${index + 1}`);
          }
        }

        if (item.container_id === "") {
          isValid = false;
          return self.$vToastify.error("Seleccione un Tipo de Contenedor", `Error en Tipo de Contenedor: Nuevo plan ${index + 1}`);
        }
        if (item.product_id === "") {
          isValid = false;
          return self.$vToastify.error("Seleccione un Tipo de Producto", `Error en Tipo de Producto: Nuevo plan ${index + 1}`);
        }

        item.weekly_plans.forEach(function callback(week, week_index) {
          if (self.psIsAdmin) {
            if (week.ucc_qty === "") {
              isValid = false;
              return self.$vToastify.error(`Ingrese una cantidad mayor o igual a cero en la planificación para la semana ${self.psCurrentWeeks[week_index]} del plan ${index + 1}`, `Error Cantidad planificación: Nuevo plan ${index + 1}`);
            }
          } else {
            if (week.client_qty === "") {
              isValid = false;
              return self.$vToastify.error(`Ingrese una cantidad mayor o igual a cero en la planificación para la semana ${self.psCurrentWeeks[week_index]} del plan ${index + 1}`, `Error Cantidad planificación: Nuevo plan ${index + 1}`);
            }
          }
        });
      });

      if (isValid) {

        this.actionSetPSEnabledButtons(false);
        this.$vToastify.loader("Modificando planificaciones semanales...");

        let response = await editarPlanificacionSemanal(this.psDataSelected, this.new_plans);

        if (response.code === 200) {

          await this.closeManageModal();
          await this.actionSetDataPlanificacionSemanalTabla();
          this.$vToastify.success(response.message, "Éxito");

        } else if (response.code && response.errors) {

          Object.values(response.errors).forEach(errorArray => {
            errorArray.forEach(error => {
              this.$vToastify.error(error, "Error");
            });
          });

        } else {

          this.$vToastify.error(response.message, "Error");
        }

        this.$vToastify.stopLoader();
        this.actionSetPSEnabledButtons(true);
      }
    },
    //gestionar los planes que se agregan nuevos
    async addNewWeeklyPlan() {

      if (this.new_plan_obj.port_id === "") {
        return this.$vToastify.error("Seleccione un puerto", "Error: Puerto");
      }

      if (this.psIsAdmin) {
        if (this.new_plan_obj.client_id === "") {
          return this.$vToastify.error("Seleccione un cliente", "Error: Cliente");
        }
      }

      if (this.new_plan_obj.container_id === "") {
        return this.$vToastify.error("Seleccione un Tipo de Contenedor", "Error: Tipo de Contenedor");
      }
      if (this.new_plan_obj.product_id === "") {
        return this.$vToastify.error("Seleccione un Tipo de Producto", "Error: Tipo de Producto");
      }

      const self = this;
      let isValid = true;

      this.new_plan_obj.weekly_plans.forEach(function callback(week, index) {
        if (self.psIsAdmin) {
          if (week.ucc_qty === "") {
            isValid = false;
            return self.$vToastify.error(`Ingrese una cantidad mayor o igual a cero en la planificación para la semana ${self.psCurrentWeeks[index]}`, "Error: Cantidad planificación");
          }
        } else {
          if (week.client_qty === "") {
            isValid = false;
            return self.$vToastify.error(`Ingrese una cantidad mayor o igual a cero en la planificación para la semana ${self.psCurrentWeeks[index]}`, "Error: Cantidad planificación");
          }
        }
      });

      if (isValid) {
        const index = this.new_plans.length;
        this.new_plan_obj.temp_id = index;
        await this.actionSetPSAddedPlanningProducts({ index: index, container_id: this.new_plan_obj.container_id });
        this.new_plans.push(this.new_plan_obj);
        this.clearNewWeeklyPlanForm();
      }
    },
    //remover un plan temporal agregado
    removeNewWeeklyPlan(index) {
      this.new_plans.splice(index, 1);
    },
    //mantenedores de modal
    async clearModal() {
      this.clearNewWeeklyPlanForm();
      await this.removeCheckedToPlans();
      await this.actionSetPSDataSelected([]);
      // this.actionSetFlagFiltersPlanificacionSemanal(false);
      
      this.new_plans = [];
    },
    //limpiar modal del nuevo plan semanal
    clearNewWeeklyPlanForm() {
      this.new_plan_obj = {
        port_id: "",
        client_id: "",
        container_id: "",
        product_id: "",
        weekly_plans: [
          {
            annual_qty: 0,
            client_qty: 0,
            ucc_qty: 0
          },
          {
            annual_qty: 0,
            client_qty: 0,
            ucc_qty: 0
          },
          {
            annual_qty: 0,
            client_qty: 0,
            ucc_qty: 0
          },
          {
            annual_qty: 0,
            client_qty: 0,
            ucc_qty: 0
          },
          {
            annual_qty: 0,
            client_qty: 0,
            ucc_qty: 0
          }
        ]
      };
    },
    openModal(ref) {
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },
    async closeManageModal() {
      await this.clearModal();
      this.ActionSetZindexTablaModal(false);
      this.actionSetPSCreateMode(false);
      this.actionSetPSShowManageModal(false);
      this.closeModal("gestionar-ps-modal");
    },
    async openManageModal() {
      this.actionSetPSEnabledButtons(true);
      this.ActionSetZindexTablaModal(true);
      this.actionSetPSShowManageModal(true);
      this.openModal("gestionar-ps-modal");
    },
    //remover los checks a los checkboxes
    async removeCheckedToPlans() {
      this.psDataSelected.forEach(item => {
        document.getElementById("chkbx" + item.temp_id).checked = false;
      });
    },
    //
    async setNewPSProducts() {
      this.new_plan_obj.product_id = "";
      await this.actionSetPSNewPlanningProducts(this.new_plan_obj.container_id);
    },
    setExistingPSProducts(data) {
      this.psDataSelected[this.psDataSelected.findIndex(i => i.temp_id === data.index)].product_id = "";
      this.actionSetPSExistingPlanningProducts(data);
    },
    setAddedPSProducts(data) {
      this.new_plans[data.index].product_id = "";
      this.actionSetPSAddedPlanningProducts(data);
    }
  },
  watch: {
    psCreateMode: function(_new) {
      if (_new) {
        this.clearNewWeeklyPlanForm();
        this.add_new = true;
        this.management_title = "Nuevos planes semanales creados";
        this.openManageModal();
      } else {
        this.clearModal();
        this.add_new = false;
        this.management_title = "Planes semanales existentes";
      }
    },
    psShowManageModal: function(_new) {
      if (_new) {
        this.openManageModal();
      }
    }
  }
};
</script>

<style>

</style>